<template>
  <div class="flex flex-col gap-1">
    <span
      v-for="item in items"
      :key="item"
      class="flex items-center gap-1 text-sm text-gray-700"
    >
      <component :is="item.icon" />
      <span>{{ item.label }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import PatchCheckIcon from '~/assets/icons/icon_cart_giftcard_1.svg?component'
import BrushIcon from '~/assets/icons/icon_cart_giftcard_2.svg?component'
import TicketIcon from '~/assets/icons/icon_cart_giftcard_3.svg?component'

const props = withDefaults(
  defineProps<{
    firstLabel: string
    secondLabel: string
    thirdLabel: string
  }>(),
  {
    firstLabel: '',
    secondLabel: '',
    thirdLabel: '',
  }
)

const items = computed(() => {
  return [
    {
      icon: PatchCheckIcon,
      label: props.firstLabel,
    },
    {
      icon: BrushIcon,
      label: props.secondLabel,
    },
    {
      icon: TicketIcon,
      label: props.thirdLabel,
    },
  ]
})
</script>

<style lang="postcss" scoped>
.giftcard-booking-icon-line {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
</style>
